import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import Picture from "/components/core/picture/picture-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { StyledAssetStripComponent } from "./asset-strip-component.scss";
class AssetStripComponent extends PureComponent {
    render() {
        const { asset, title, subtitle, height, preventSignup, signupFocusOnLoad } = this.props;
        return /*#__PURE__*/ _jsxs(StyledAssetStripComponent, {
            className: "asset-strip-component",
            style: {
                height
            },
            children: [
                asset && /*#__PURE__*/ _jsx(Picture, {
                    src: asset.src,
                    alt: asset.alt
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "asset-strip-content",
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "strip-title",
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            className: "strip-subtitle",
                            children: subtitle
                        }),
                        !preventSignup && /*#__PURE__*/ _jsx("div", {
                            className: "strip-signup-wrapper",
                            children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                                focusOnLoad: signupFocusOnLoad
                            })
                        })
                    ]
                })
            ]
        });
    }
}
export { AssetStripComponent as default };
AssetStripComponent.defaultProps = {
    height: "520px"
};
